interface IInputDetailProps {
  title: string;
  value: string;
}

export const InputListDetails: React.FC<IInputDetailProps> = ({ title, value }) => {
  return (
    <div className='flex flex-col'>
      <p className='text-base font-semibold text-gray-800'>{title}:</p>
      <p className='text-base text-gray-600'>{value}</p>
    </div>
  );
};
